import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'pf-warning-message',
  imports: [],
  templateUrl: './warning-message.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class WarningMessageComponent {

  @Input() message: string = '';
  @Input() name: string = '';

}
